import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';
import type { BitcoinProvider } from 'sats-connect';

const XVERSE_BITCOIN_PROVIDER_LOCATOR = 'XverseProviders.BitcoinProvider';

export const getXverseInjectedProvider = () => {
  return getInjectedProviderFromWindow<BitcoinProvider>(
    XVERSE_BITCOIN_PROVIDER_LOCATOR
  );
};
